import reduceOpacity from '../utils/reduce-opacity';
import isDark from '../verifiers/is-dark';

const DARK_CONTRAST_RATIO = 1.3;
const LIGHT_CONTRAST_RATIO = 1.14;

const inputDisabled = (params) => {
  const { targetColor, backgroundColor } = params;
  const condition = (ratio) => {
    const maxRatio = isDark(backgroundColor) ? DARK_CONTRAST_RATIO : LIGHT_CONTRAST_RATIO;

    return ratio < maxRatio;
  };

  return reduceOpacity({
    targetColor,
    backgroundColor,
    opacity: targetColor.alpha,
    condition,
    fallback: {
      rule: 'input.borderColor.disabled',
      params,
    },
  });
};

export default inputDisabled;
